import { useSelector } from "react-redux";

import { useRecentEventForCurrentMode } from "../../../../../hooks/useRecentEventForCurrentMode";
import { selectFocusedEvent } from "../../../../../store/slices/socket/selectors";
import type { RootState } from "../../../../../store/store";
import { ContactPointVis } from "../../svg/ContactPointVis";

interface Props {
  style?: React.CSSProperties;
}

export const ContactVis = ({ style }: Props) => {
  const { isViewingPreviousEvent } = useSelector(
    (state: RootState) => state.socket,
  );
  const focusedEvent = useSelector(selectFocusedEvent);
  const recentEvent = useRecentEventForCurrentMode();

  // Toggle data based on if we are viewing a previous event or current event
  const hit_data = isViewingPreviousEvent
    ? focusedEvent.hit_data
    : recentEvent.hit_data;

  return (
    <ContactPointVis
      style={style ? style : {}}
      xFeet={hit_data?.yt_HitLocationXFeet}
      yFeet={hit_data?.yt_HitLocationYFeet}
    />
  );
};
